import * as t from "io-ts";

export const CompanyDirectorReport = t.type({
  people_id: t.string,
  director_name: t.string,
  number_of_current_appointments: t.number,
  current_appointment_ccj: t.number,
  number_of_inactive_appointments: t.number,
  inactive_appointment_ccj: t.number,
  number_of_previous_appointments: t.number,
  previous_appointment_ccj: t.number,
  disqualified: t.boolean,
});

export interface CompanyDirectorReport {
  people_id: string;
  director_name: string;
  number_of_current_appointments: number;
  current_appointment_ccj: number;
  number_of_inactive_appointments: number;
  inactive_appointment_ccj: number;
  number_of_previous_appointments: number;
  previous_appointment_ccj: number;
  disqualified: boolean;
}
